import ReactDOM from 'react-dom/client';
import '@bancobarigui/barihaus/dist/index.css';
import App from './App';

// Disable New Relic monitoring BEFORE SDK loads to prevent interception
const nreum = (window as any).NREUM;
if (nreum) {
  // Disable automatic instrumentation that intercepts fetch/xhr
  if (nreum.agent && typeof nreum.agent.stopSendingEvents === 'function') {
    nreum.agent.stopSendingEvents();
  }

  // Disable feature that causes #64 warning
  if (nreum.setErrorHandler) {
    nreum.setErrorHandler(() => {
      // Suppress error handling
    });
  }

  // Disable resource timing collection
  if (typeof nreum.noticeError === 'function') {
    const originalNoticeError = nreum.noticeError;
    nreum.noticeError = function(error: any) {
      // Suppress errors from ozliveness/dorothy SDK
      if (error?.message?.includes('ozliveness') ||
          error?.message?.includes('dorothy') ||
          error?.stack?.includes('ozliveness') ||
          error?.stack?.includes('dorothy')) {
        return;
      }
      return originalNoticeError.call(this, error);
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
